import React from 'react';

// export default ({ progress, total }) => (
//   <progress className="progress is-danger is-small" value={ ((progress + 1) / total) * 100} max="100">
//     { ((progress + 1) / total) * 100}%
//   </progress>
// )
export default ({ progress, total }) => (
  <div className="progress-bar-container">
    <div className="progress-bar is-danger" style={{width: `${((progress + 1) / total) * 100}%`}}></div>
  </div>
)



// WEBPACK FOOTER //
// ./src/components/progress-bar/index.js